<script setup lang="ts">
defineProps<{
  visible: boolean
  previousDisabled: boolean
  nextVisible: boolean
}>()

defineEmits<{
  previous: [event: MouseEvent]
  next: [event: MouseEvent]
}>()
</script>

<template>
  <div v-if="visible" class="actions clearfix">
    <ul role="menu" aria-label="Pagination">
      <li :class="{ disabled: previousDisabled }" :aria-disabled="previousDisabled ? 'true' : 'false'">
        <a href="#previous" role="menuitem" @click="$emit('previous', $event)">Previous</a>
      </li>
      <li v-if="nextVisible" aria-hidden="false" aria-disabled="false">
        <a href="#next" role="menuitem" @click="$emit('next', $event)">Next</a>
      </li>
    </ul>
  </div>
</template>
